import * as React from 'react';

/**
 * Production chunks from @cw-ui can execute before the app entry body runs.
 * Bind React on globalThis first so post-build interop patches can safely
 * redirect broken aliases to globalThis.React.
 */
(globalThis as typeof globalThis & { React: typeof React }).React = React;

await import('./main');
